module.exports = __webpack_public_path__ + "img/shareholderCard8.5df30171.png";